(function ($) {
  var $document = $(document);
  $document.ready(function () {
    //add quantity field only to simple products on the shop page
    $(".woocommerce-shop form.cart").on("change", "input.qty", function () {
      $(this.form).find("[data-quantity]").attr("data-quantity", this.value); //used attr instead of data, for WC 4.0 compatibility

      var optionalProduct = $('.product-optional[data-parent="' + $(this).parents('.product').data('product') + '"]');

      if (this.value >= 100) {
        optionalProduct.show();
      } else {
        optionalProduct.hide();
      }

      optionalProduct.find('.qty').attr('max', this.value).val(this.value).attr('value', this.value);
      optionalProduct.find('.ajax_add_to_cart').attr("data-quantity", this.value);
      optionalProduct.find('.message span').text(this.value);
      optionalProduct.find('.message').show();

      if ($(this).parents('.product').hasClass('product-optional')) {
        if (Number(this.value) > Number($(this).attr('max')) || Number(this.value) <= 0) {
          $(this).val($(this).attr('max'));
          $(this.form).find("[data-quantity]").attr("data-quantity", $(this).attr('max'));
        }
      }

      getProductSubtotal($(this));
    });
    $(document.body).on("adding_to_cart", function ($init, $el) {
      $("a.added_to_cart").remove();
      /*var $parent = $($el).parents('.product');
      if ( $parent.find('[name="quantity"]').val() >= 100 ) {
          $('.product-optional[data-parent="' + $parent.data('product') + '"]').find('.add_to_cart_button').removeAttr('disabled');
      }*/
    });
    $(document.body).on("added_to_cart", function () {
      getCountCart();
    });
    /*$(document.body).on("added_to_cart", function( data ) {
        $(".added_to_cart").after("<p class='confirm_add'>Item Added</p>");
    });*/

    $document.on('change', '.quantity select', function () {
      $(this).parents('.quantity').find('[name="quantity"]').val($(this).val());
      $(this).parents('.quantity').find('[name="quantity"]').change();
    });

    if ($('.link-shop').length) {
      getCountCart();
    }

    $(document.body).on('wc_fragments_refreshed', function () {
      if ($('.link-shop').length) {
        getCountCart();
      }
    });
    $document.on('submit', '.js-active-key', function (e) {
      e.preventDefault();
      var $form = $(this);
      $form.find('.box-error').html('').css({
        display: 'none'
      });
      var licenseKey = $form.find('[name="license_key"]').val();
      var data = {
        action: 'active_license_key',
        licenseKey: licenseKey
      };
      $.ajax({
        url: reqObj.ajaxUrl,
        dataType: 'json',
        method: 'post',
        data: data,
        beforeSend: function beforeSend(xhr) {},
        success: function success(data) {
          if (data) {
            if (!data.valid) {
              $form.find('.box-error').html(data.message).css({
                display: 'block'
              });
            }

            if (data.valid && data.active) {
              $form.closest('.block-unlock-digibook').next('.block-popup-confirmation').find('.block-content').html(data.message);
              $form.closest('.block-unlock-digibook').next('.block-popup-confirmation').addClass('open-popup');
            }
          }
        },
        error: function error(jqXHR, textStatus, errorThrown) {}
      });
    });
  });
  /*$(window).on( 'storage onstorage', function ( e ) {
      getCountCart();
  });*/

  function getCountCart() {
    var data = {
      action: 'get_count_cart'
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        if (data && data.countCart > 0) {
          $('.link-shop .box-num').text(data.countCart).show();
        } else {
          $('.link-shop .box-num').text('').hide();
        }
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }

  function getProductSubtotal(el) {
    var quantity = el.val();
    var product_id = el.parents('form.cart').find('.add_to_cart_button').data('product_id');
    var data = {
      action: 'get_product_subtotal',
      quantity: quantity,
      product_id: product_id
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        if (data && data.product_subtotal.length) {
          el.parents('.product').find('.price').html(data.product_subtotal);
        } else {}
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }
})(jQuery);